jQuery(function ($) {
  $(function () {
    const SPEED = 100; // pixels per second — increase = faster

    function waitForImages($el) {
      const $imgs = $el.find('img');
      if (!$imgs.length) return Promise.resolve();
      let loaded = 0;
      return new Promise((resolve) => {
        $imgs.each(function () {
          if (this.complete) {
            loaded++;
            if (loaded === $imgs.length) resolve();
          } else {
            $(this).on('load error', function () {
              loaded++;
              if (loaded === $imgs.length) resolve();
            });
          }
        });
        // safety timeout in case load events never fire
        setTimeout(resolve, 1500);
      });
    }

    function initScroller($wrap) {
      // ensure styles needed
      $wrap.css({ overflow: 'hidden', position: 'relative' });

      // move children into a track container
      let $originalChildren = $wrap.children().not('.scroll-track');
      if ($originalChildren.length === 0 && $wrap.find('.scroll-track').length) {
        // already initialized, use existing track's children
        $originalChildren = $wrap.find('.scroll-track').children();
        $wrap.find('.scroll-track').remove();
      }

      const contentHtml = $('<div/>').append($originalChildren.clone(true)).html();
      $wrap.empty().append(`<div class="scroll-track" style="display:flex;white-space:nowrap;">${contentHtml}</div>`);
      const $track = $wrap.find('.scroll-track');

      return waitForImages($wrap).then(() => {
        // duplicate until track width >= 2 * wrap width (so seamless)
        let wrapW = Math.round($wrap.width());
        let trackW = $track[0].scrollWidth;
        // If the content was not enough, keep appending clones until it's large enough
        let attempts = 0;
        while (trackW < wrapW * 2 && attempts < 10) {
          $track.append($track.children().clone(true));
          trackW = $track[0].scrollWidth;
          attempts++;
        }

        // Use halfTrackWidth if we duplicated once; safer to compute the repeating chunk width:
        // find width of one "unit" by taking total track width divided by number of identical groups
        // we don't know groups count exactly; safer and simpler: find smallest repeating width by trying to find first child offset that equals wrapW etc.
        // For simplicity we treat half: we'll animate by half the total duplicated content (works because we duplicated until >= 2x)
        const repeatChunk = trackW / Math.ceil(trackW / wrapW); // conservative estimate (not exact, but works)
        // simpler and reliable approach:
        const halfTrack = trackW / 2;

        // cleanup any previous tweens
        gsap.killTweensOf($track);

        // duration based on pixel distance and speed
        const distance = halfTrack; // move by half the track (we duplicated content at least once)
        const duration = Math.max(5, distance / SPEED);

        gsap.to($track, {
          x: -distance,
          ease: 'none',
          repeat: -1,
          duration: 20,
          modifiers: {
            x: (x) => {
              // normalize and wrap so there's no jump
              let val = parseFloat(x);
              if (isNaN(val)) val = 0;
              // wrap value into range [-distance, 0)
              const wrapped = ((val % -distance) + -distance) % -distance;
              return `${wrapped}px`;
            }
          }
        });

        // performance hint
        $track.css({ willChange: 'transform' });

        return true;
      });
    }

    // initialize all scrollers and handle resizes
    let inits = [];
    function initAll() {
      // kill previously created tweens before re-init
      gsap.globalTimeline.clear();
      $('.animated-scroller .scroller-wrap').each(function () {
        inits.push(initScroller($(this)));
      });
      return Promise.all(inits);
    }

    // initial init
    initAll();

    // re-init on resize (debounced)
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // kill tweens and re-init
        $('.animated-scroller .scroller-wrap').each(function () {
          const $t = $(this).find('.scroll-track');
          if ($t.length) {
            gsap.killTweensOf($t);
          }
        });
        inits = [];
        initAll();
      }, 250);
    });
  });
});
